import {Mutation, Action} from 'vuex'
import {StoreModuleType} from '@/utils/store'
import {ResponseData} from '@/utils/request'

import {getPageList,getInfo,save,deleteFn,addressDefault,updateUserAddress} from './service'

import {
    TableListQueryParams, 
    TableDataType, 
    InfoParamsType, 
    SaveFormDataType,  
    IsDefaultAddressType,
    InfoResType
} from './data.d'

export interface StateType {
    errorMsg?: string;
    tableData: TableDataType;
    infoData: InfoResType;
}

export interface ModuleType extends StoreModuleType<StateType>{
    state: StateType;
    mutations: {
        changeErrorMsg: Mutation<StateType>;
        getList: Mutation<StateType>;
        getInfodata: Mutation<StateType>;
    };
    actions: {
        getPageListFn: Action<StateType, StateType>;
        getInfoFn: Action<StateType, StateType>;
        saveFn: Action<StateType, StateType>;
        addressDeleteFn: Action<StateType, StateType>;
        updateAddressFn: Action<StateType, StateType>;
        updateUserAddressFn: Action<StateType, StateType>;
    };
}

const initState: StateType = {
    errorMsg: undefined,
    tableData: {
        addresslist: [],
        pagination: {
            total: 0,
            current: 1,
            pageNo: 1,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
        },
    },
    infoData: {
        userCode: '',
        addressCode: '',
        country: '',
        province: '',
        city: '',
        region: '',
        detailedAddress: '',
        isDefault: false,
        addressType: 0,
        addressName: '',
        contacts: '',
        mobilePhone: '',
        zipCode: '',
        status: 0,
        deliveryType: 0,
        pickupStartTime: '',
        pickupEndTime: '',
        pickupCycle: '',
        createdAt: '',
        updatedAt: '',
        collectDriver: '',
        collectDriverPhone: '',
        auditStatus: 0,
    }
}

const StoreModel: ModuleType = {
    namespaced: true,
    name: 'setaddress',
    state: {
        ...initState
    },
    mutations: {
        changeErrorMsg(state, payload) {
            state.errorMsg = payload;
        },
        getList(state, payload){
            state.tableData = payload
        },
        getInfodata(state, payload){
            state.infoData = payload
        },
    },
    actions: {
        //获取地址列表信息
        async getPageListFn({commit}, params:TableListQueryParams){
            let msg: string | undefined = undefined
            try{
                const req: ResponseData = await getPageList(params)
                const { body } = req
                const data = body?.datas || []
                const newData = data.map((item: any) => {
                    return {...item, isDefault: item.isDefault == 1 ? true : false}
                })
                commit('getList', {
                    ...initState.tableData,
                    addresslist: newData || [],
                    pagination: {
                        ...initState.tableData.pagination,
                        current: params.pageNo,
                        pageNo: params.pageNo,
                        pageSize: params.pageSize,
                        total: body.sumDataCount
                    }
                })
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },

        //获取地址单条信息
        async getInfoFn({commit}, params:InfoParamsType){
            let msg: string | undefined = undefined
            try{
                const req: ResponseData = await getInfo(params)
                const { body } = req
                commit('getInfodata', body)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },

        //添加地址信息
        async saveFn({commit}, params:SaveFormDataType){
            let msg: string | undefined = undefined
            try{
                await save(params)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },

        //更新地址
        async updateUserAddressFn({commit}, params:SaveFormDataType){
            let msg: string | undefined = undefined
            try{
                await updateUserAddress(params)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },

        //删除地址
        async addressDeleteFn({commit}, params:InfoParamsType){
            let msg: string | undefined = undefined
            try{
                await deleteFn(params)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },

        //更新默认地址
        async updateAddressFn({commit}, params:IsDefaultAddressType){
            let msg: string | undefined = undefined
            try{
                await addressDefault(params)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
    }
}

export default StoreModel
